import type { MaterialTopTabBarProps } from "@-/com.npmjs.expo-router/material-top-tabs";

export type TabBarControls = Pick<MaterialTopTabBarProps, "state" | "navigateToTab"> & {
  descriptors: Record<string, Pick<MaterialTopTabBarProps["descriptors"][string], "options">>;
  emitter: {
    emit(event: {
      canPreventDefault?: boolean;
      target: string;
      type: "tabPress" | "tabLongPress";
    }): { defaultPrevented?: boolean };
  };
};

type MaterialTopTabRoute = { key: string; name: string; params: undefined };
type CreateMaterialTopTabBarPropsInput = {
  activeIndex: number;
  getOptions: (route: MaterialTopTabRoute) => TabBarControls["descriptors"][string]["options"];
  navigate: (routeName: string) => void;
  routes: MaterialTopTabRoute[];
  stateKey: string;
  withDispatchNavigation?: boolean;
};

export function createMaterialTopTabBarProps({
  activeIndex,
  getOptions,
  navigate,
  routes,
}: CreateMaterialTopTabBarPropsInput): TabBarControls & Pick<MaterialTopTabBarProps, "insets"> {
  return {
    descriptors: Object.fromEntries(
      routes.map((route) => [route.key, { options: getOptions(route) }]),
    ),
    emitter: { emit: () => ({ defaultPrevented: false }) },
    // Embedded strips sit inside the screen's safe area already.
    insets: { bottom: 0, left: 0, right: 0, top: 0 },
    navigateToTab(key) {
      const route = routes.find((route) => route.key === key);
      if (route) {
        navigate(route.name);
      }
    },
    state: { index: activeIndex, routes },
  };
}
